import { ContentfulModel } from '@/types/contentful'

export function getCachedContentful(key: string): ContentfulModel | null {
  try {
    const item = window.localStorage.getItem(`contentful_${key}`)
    return item ? (JSON.parse(item) as ContentfulModel) : null
  } catch {
    return null
  }
}

export function setCachedContentful(key: string, value: ContentfulModel) {
  try {
    window.localStorage.setItem(`contentful_${key}`, JSON.stringify(value))
  } catch {}
}
